import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { ref } from "vue";

import { getTranslation } from "~/js/composables/translations";
import { getClasses } from "~/js/composables/classes";

import { Document } from "~/js/interfaces/file-manager";
import { Translations } from "~/js/interfaces/translations";

import CardDocument from "~/vue/molecules/cards/CardDocument.vue";
import CardKnowledgeHub from "~/vue/molecules/cards/CardKnowledgeHub.vue";
import CardPress from "~/vue/molecules/cards/CardPress.vue";
import CardPrimary from "~/vue/molecules/cards/CardPrimary.vue";
import CardExternalLink from "~/vue/molecules/cards/CardExternalLink.vue";

interface Props {
	translations?: Translations | null;
	documents: Array<Document> | null;
	mode?: "dark" | "light";
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GridDocuments',
  props: {
    translations: { default: null },
    documents: {},
    mode: { default: "light" },
    utilities: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const classes = ref({
	wrapper: {
		grid: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
		spacing: "gap-6",
		utilities: props.utilities,
	},
});

const knowledgeHubTypes = ref(["blog", "caseStudy", "dossier", "news", "whitepaper", "event"]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(getClasses)(classes.value, 'wrapper'))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.documents, (document) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (document.fileType == 'file')
          ? (_openBlock(), _createBlock(CardDocument, {
              key: document.id,
              document: document,
              background: __props.mode === 'light' ? 'bg-concrete-200' : 'bg-white'
            }, null, 8, ["document", "background"]))
          : _createCommentVNode("", true),
        (document.fileType == 'link')
          ? (_openBlock(), _createBlock(CardExternalLink, {
              key: document.id,
              card: document,
              "show-teaser": false,
              background: __props.mode === 'light' ? 'bg-concrete-200' : 'bg-white'
            }, null, 8, ["card", "background"]))
          : _createCommentVNode("", true),
        (
					document.fileType == 'page' &&
						!knowledgeHubTypes.value.includes(document.type) &&
						document.type !== 'pressRelease'
				)
          ? (_openBlock(), _createBlock(CardPrimary, {
              key: document.id,
              card: document,
              "show-teaser": false,
              background: __props.mode === 'light' ? 'bg-concrete-200' : 'bg-white'
            }, null, 8, ["card", "background"]))
          : _createCommentVNode("", true),
        (document.fileType == 'page' && knowledgeHubTypes.value.includes(document.type))
          ? (_openBlock(), _createBlock(CardKnowledgeHub, {
              key: document.id,
              card: document,
              "show-teaser": false,
              background: __props.mode === 'light' ? 'bg-concrete-200' : 'bg-white'
            }, null, 8, ["card", "background"]))
          : _createCommentVNode("", true),
        (document.fileType == 'page' && document.type === 'pressRelease')
          ? (_openBlock(), _createBlock(CardPress, {
              key: document.id,
              card: document,
              "show-teaser": false,
              background: __props.mode === 'light' ? 'bg-concrete-200' : 'bg-white',
              translations: __props.translations,
              "hide-tags": true
            }, null, 8, ["card", "background", "translations"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ], 2))
}
}

})